import { ComponentPropsWithoutRef, ReactElement } from "react";
import { SectionBlockAccordionContent as ISectionBlockAccordionContent } from "~/sanity/types";
import Grid from "~/components/globals/Grid";
import * as styles from "./SectionBlockAccordionContent.css";
import { Accordion } from "~/components/elements/Accordion";
import { Heading } from "~/components/elements/Heading";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { ButtonLink } from "~/components/elements/ButtonLink";
// @ts-ignore
import Phone from "@material-design-icons/svg/outlined/phone.svg?react";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";

export type SectionBlockAccordionContentProps =
  ComponentPropsWithoutRef<"div"> & {
    data: ISectionBlockAccordionContent;
    icon?: ReactElement;
  };

export const SectionBlockAccordionContent = ({
  data,
  icon,
  ...props
}: SectionBlockAccordionContentProps) => {
  const { title, text, link, accordion } = data;

  return (
    <section>
      <Grid className={styles.wrapper} {...props}>
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            {icon && <div className={styles.icon}>{icon}</div>}
            {title && (
              <Heading as="h2" size="h2" bold uppercase>
                {title}
              </Heading>
            )}
            {text && <PortableText blocks={text as IPortableText} />}
          </div>
          {link && link.slug && (
            <div className={styles.link}>
              <ButtonLink
                link={link}
                theme="dark"
                icons={{
                  iconPrimary: link.slug.includes("tel") ? (
                    <Phone />
                  ) : (
                    <ArrowOutward />
                  ),
                }}
              >
                {link.text}
              </ButtonLink>
            </div>
          )}
        </div>
        <div className={styles.accordion}>
          {accordion && <Accordion accordionItems={accordion} />}
        </div>
      </Grid>
    </section>
  );
};
